export * from './intl.service';
export * from './cldr-intl.service';
export * from './date.pipe';
export * from './number.pipe';
export * from './intl.module';
export * from './intl-members';



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-angular-intl/dist/es/main.js
// module id = ../../../../@progress/kendo-angular-intl/dist/es/main.js
// module chunks = 3